import React, { Component } from "react";
import { AddCircleOutline, RemoveCircleOutline } from "@material-ui/icons";
import { connect } from "react-redux";
import Loading from "../Loading";
import { getCurrencyIcon } from "../../Helpers/currencyConverter";
class ProductQuantity extends Component {
  getUnit() {
    const { current_product, language } = this.props;
    if (!current_product.unit) return "";

    if (language === "arabic") {
      return `لكل ${current_product.unit.ar_name}`;
    }
    return `per ${current_product.unit.name}`;
  }
  render() {
    const themeColor = this.props.themeColor
      ? this.props.themeColor
      : "#0099cc";

    if (!this.props.current_product) return <Loading />;
    const { current_product, language, settings } = this.props;
    const currency =
      this.props.language === "english"
        ? settings.currency_english
        : settings.currency_local;
    const real_price = this.props.price_with_discount;

    const has_striked_price =
      current_product.striked_price &&
      current_product.striked_price > current_product.price;
    const currencyIcon = getCurrencyIcon(settings)
    return (
      <div
        style={{
          height: "60px",
          verticalAlign: "middle",
          marginTop: this.props.type == "bottom" ? 20 : 0,
        }}
      >
        <div
          className={"mt-3 ".concat(
            this.props.language == "english" ? "float-right " : "float-left ",
          )}
          style={{ width: "150px", height: "30px" }}
        >
          {current_product.price <= 0 ? (
            <span
              style={{ fontWeight: "bold", color: themeColor, font: "20px" }}
            >
              {window.location.hostname?.includes("generalassembly.ordable.com")
                ? "Talent on selection"
                : (language === "arabic" && "السعر عند الاختيار") ||
                  "Price on selection"}
            </span>
          ) : current_product.price !== undefined &&
            !current_product.has_variants ? (
            current_product.price <= real_price && !has_striked_price ? (
              <span
                className={""
                  .concat(
                    this.props.language == "english"
                      ? "float-left ml-3 rtl"
                      : "float-right mr-3",
                  )
                  .concat(` ${currencyIcon}`)}
                style={{
                  fontWeight: "bold",
                  color: themeColor,
                  font: "20px",
                  direction: this.props.language == "english" ? "ltr" : "rtl",
                  whiteSpace: "nowrap",
                }}
              >
                {`${real_price.toFixed(
                  settings.currency_decimals,
                )} ${currency} ${this.getUnit()}`}
              </span>
            ) : (
              <span
                className={""
                  .concat(
                    this.props.language == "english"
                      ? "float-left ml-4 rtl"
                      : "float-right mr-4",
                  )
                  .concat(currencyIcon)}
                style={{
                  fontWeight: "bold",
                  color: themeColor,
                  font: "20px",
                  direction: this.props.language == "english" ? "ltr" : "rtl",
                  whiteSpace: "nowrap",
                  position: "relative",
                }}
              >
                <span
                  style={{
                    textDecoration: "line-through",
                    display: "inline",
                    fontSize: 11,
                    position: "absolute",
                    top: -15,
                    left: 6,
                  }}
                >{`${
                  has_striked_price
                    ? current_product.striked_price.toFixed(
                        settings.currency_decimals,
                      )
                    : current_product.price.toFixed(settings.currency_decimals)
                } ${currency}`}</span>
                {`${real_price.toFixed(
                  settings.currency_decimals,
                )} ${currency}`}
              </span>
            )
          ) : null}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    current_product: state.store.current_product,
    themeColor: state.store.store.settings.dark,
    settings: state.store.store.settings,
  };
};

export default connect(mapStateToProps)(ProductQuantity);
